import {transform} from "ol/proj";
import {getLocationById, getLocationReversed} from "@/http/services/http-services-route";
import {replaceStringValue} from "@/helpers/info-overview-helper";
import {getWizardItems} from "@/helpers/smart-wizard-helper";
import {showNotification} from "@/helpers/toastr-helper";
import {getLayerByName, removeLayer} from "@/helpers/ol-layer-helper";
import {getDefaultName} from "@/helpers/geo-json-helper";

const duration = 500

export function zoomIn() {
    window.map.getView().animate({
        zoom: map.getView().getZoom() + 1,
        duration: duration
    })
}

export function zoomOut() {
    window.map.getView().animate({
        zoom: map.getView().getZoom() - 1,
        duration: duration
    })
}

export function loadMapClick(coordinate) {
    const xy = transform(coordinate, 'EPSG:3857', 'EPSG:4326')
    getLocationReversed(xy[1], xy[0]).then((locationReversed) => {

        getLocationById(locationReversed.adres.id).then((result) => {

            const location = result.response.docs[0]

            let selectedItem = `
                    <div class="alert alert-secondary alert-dismissible fade show">
                        <span class="fa fa-map-marker"></span> Klik op de kaart of voer een adres in
                    </div>`

            const layer = getLayerByName('Geonovation:Gebiedsbeperking')
            if(layer) {
                const intersects = layer.getSource().getFeatures()[0].getGeometry().intersectsCoordinate(coordinate)
                if(!intersects) {
                    showNotification('Er kan hier geen melding plaatst worden', '', 'warning')
                    document.getElementById('selectedItem').innerHTML = selectedItem
                    document.getElementById('iptNewNotificationLocation').value = ''
                    removeLayer(getDefaultName())
                    return
                }
            } else {
                if (window.wizard.settings.ProvincieCode) {
                    if (window.wizard.settings.ProvincieCode !== location.provinciecode) {
                        showNotification('Er kan hier geen melding plaatst worden', '', 'warning')
                        document.getElementById('selectedItem').innerHTML = selectedItem
                        document.getElementById('iptNewNotificationLocation').value = ''
                        removeLayer(getDefaultName())
                        return
                    }
                }
            }
            selectedItem = `
                    <div class="alert alert-success alert-dismissible fade show">
                        <span class="fa fa-check"></span> U heeft een locatie gekozen
                    </div>`

            document.getElementById('selectedItem').innerHTML = selectedItem

            document.getElementById('iptNewNotificationLocation').value = location.weergavenaam

            getWizardItems().map(item => {
               if(hasReplaceStringValue(item.DefaultValue)) {
                   document.querySelector('form-element[data-id="' + item.AttributeID + '"] input').value = item.DefaultValue
               }
            })

            const latLon = transform(coordinate, 'EPSG:3857', 'EPSG:28992')
            replaceStringValue('$coordx', xy[0])
            replaceStringValue('$coordy', xy[1])
            replaceStringValue('$coordlat', latLon[0])
            replaceStringValue('$coordlon', latLon[1])

            replaceStringValue('$straat', location.straatnaam)
            replaceStringValue('$huisnummer', location.huisnummer)
            replaceStringValue('$huisletter', location.huisletter)
            replaceStringValue('$toevoeging', location.toevoeging)
            replaceStringValue('$woonplaats', location.woonplaatsnaam)
            replaceStringValue('$postcode', location.postcode)
            replaceStringValue('$gemcode', location.gemeentecode)
            replaceStringValue('$gemeente', location.gemeentenaam)
            replaceStringValue('$perceel', locationReversed.perceel.weergavenaam)
        })
    })
}

/**
 *
 * @param value
 * @returns {boolean}
 */
function hasReplaceStringValue(value) {
    let result = false

    getReplaceStringValues().map(item => {
        if(value && String(value).includes(item)) {
            result = true
        }
    })
    return result
}

function getReplaceStringValues() {
    return ['$coordx', '$coordy', '$coordlat', '$coordlon', '$straat', '$huisnummer', '$huisletter', '$toevoeging', '$woonplaats', '$postcode', '$gemcode', '$gemeente', '$perceel']
}
